import React, { useState } from 'react';
import { AlertTriangle, Filter, MoreVertical, Plus } from 'lucide-react';

export default function InventoryList() {
    const [inventory] = useState([
        { id: "BOS-001", name: "Paracetamol 500mg", category: "Analgesic", stock: 450, status: "In Stock", expiry: "2026-12" },
        { id: "BOS-042", name: "Amoxicillin Syrup", category: "Antibiotic", stock: 8, status: "Low Stock", expiry: "2024-05" },
        { id: "BOS-102", name: "Vitamin C Tablets", category: "Supplement", stock: 1200, status: "In Stock", expiry: "2027-01" },
    ]);

    return (
        <div className="animate-in fade-in duration-500">
            <div className="flex justify-between items-end mb-10">
                <div>
                    <h1 className="text-4xl font-extrabold text-slate-800 tracking-tight">Medicine Inventory</h1>
                    <p className="text-slate-500 font-medium mt-1">Manage and monitor stock levels for Boseth programs.</p>
                </div>
                <button className="bg-emerald-600 hover:bg-emerald-700 text-white flex items-center gap-2 px-6 py-3 rounded-2xl shadow-lg shadow-emerald-600/20 transition-all active:scale-95 font-bold">
                    <Plus size={20} /> Add New Medicine
                </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
                <div className="bg-white p-6 rounded-[2.5rem] shadow-sm border border-slate-100">
                    <p className="text-slate-400 text-[10px] font-black uppercase tracking-widest mb-2">Total Stock</p>
                    <h3 className="text-4xl font-black text-slate-800">1,420 <span className="text-xs font-normal text-slate-400">items</span></h3>
                </div>
                <div className="bg-white p-6 rounded-[2.5rem] shadow-sm border border-slate-100">
                    <p className="text-orange-500 text-[10px] font-black uppercase tracking-widest mb-2 flex items-center gap-1">
                        <AlertTriangle size={12} /> Critical Attention
                    </p>
                    <h3 className="text-4xl font-black text-orange-600">12 <span className="text-xs font-normal text-slate-400">low stock</span></h3>
                </div>
                <div className="bg-white p-6 rounded-[2.5rem] shadow-sm border border-slate-100">
                    <p className="text-slate-400 text-[10px] font-black uppercase tracking-widest mb-2">Revenue Share</p>
                    <h3 className="text-4xl font-black text-blue-600 italic">Rs. 24,500</h3>
                </div>
            </div>

            {/* Table */}
            <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-100 overflow-hidden">
                <div className="p-8 border-b border-slate-50 flex items-center justify-between bg-slate-50/30">
                    <h2 className="font-bold text-slate-800">Stock Directory</h2>
                    <button className="text-slate-400 hover:text-emerald-500 transition-colors flex items-center gap-2 text-sm font-bold"><Filter size={16}/> FILTER</button>
                </div>
                <div className="overflow-x-auto px-4">
                    <table className="w-full text-left">
                        <thead>
                        <tr className="text-slate-400 text-[10px] uppercase tracking-widest border-b font-black">
                            <th className="px-6 py-5">Item ID</th>
                            <th className="px-6 py-5">Name</th>
                            <th className="px-6 py-5">Category</th>
                            <th className="px-6 py-5">Stock</th>
                            <th className="px-6 py-5">Status</th>
                            <th className="px-6 py-5 text-right">Action</th>
                        </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-50">
                        {inventory.map((item, index) => (
                            <tr key={index} className="group hover:bg-slate-50/50 transition-all">
                                <td className="px-6 py-5 font-mono text-xs text-slate-400">{item.id}</td>
                                <td className="px-6 py-5 font-bold text-slate-800">{item.name}</td>
                                <td className="px-6 py-5"><span className="bg-slate-100 text-slate-600 text-[11px] px-3 py-1 rounded-lg font-bold">{item.category}</span></td>
                                <td className="px-6 py-5 font-black text-slate-700 text-lg">{item.stock}</td>
                                <td className="px-6 py-5">
                                    <div className={`flex items-center gap-2 text-[10px] font-black uppercase ${item.status === 'Low Stock' ? 'text-orange-500' : 'text-emerald-500'}`}>
                                        <span className={`w-2 h-2 rounded-full ${item.status === 'Low Stock' ? 'bg-orange-500 animate-pulse' : 'bg-emerald-500'}`}></span>
                                        {item.status}
                                    </div>
                                </td>
                                <td className="px-6 py-5 text-right"><MoreVertical size={18} className="text-slate-300 group-hover:text-slate-600 inline-block cursor-pointer" /></td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}